import i18n from '@/lang/i18n'
import { AgGridColumnType, AgGridExportType, ExportedColDef, ExportedColGroupDef } from '@/shared/models/ag-grid.model'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { ICellRendererParams } from '@ag-grid-community/core/dist/cjs/rendering/cellRenderers/iCellRenderer'

export const sectionPortionGridColumnDefs: (ColDef | ExportedColDef | ExportedColGroupDef)[] = [
    { type: AgGridColumnType.CUSTOM_CHECKBOX },
    {
        headerName: i18n.tc('globalLocator.labels.portionTag'),
        colId: 'porLabel',
        field: 'portionLabel',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.portionId'),
        colId: 'porPortionnumber',
        field: 'portionNumber',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true
    },
    {
        headerName: i18n.tc('grid.detail.depletedBlock'),
        field: 'depleted',
        type: AgGridColumnType.CHECK_ICON,
        exportType: AgGridExportType.BOOLEAN,
        width: 135
    },
    {
        headerName: i18n.tc('grossing.portionGrid.status'),
        field: 'status',
        type: AgGridColumnType.COMMON_PORTION_STATUS,
        exportField: 'status.name',
        exportType: AgGridExportType.TEXT,
        width: 120
    },
    {
        headerName: i18n.tc('globalLocator.labels.sampleId'),
        colId: 'sample.samSampleNumber',
        field: 'sample.sampleNumber',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        hide: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.fragments'),
        colId: 'porFragments',
        field: 'fragments',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.orientation'),
        colId: 'fragmentOrientation.forDescription',
        field: 'fragmentOrientation',
        type: AgGridColumnType.TEXT,
        exportField: 'fragmentOrientation.forDescription',
        exportType: AgGridExportType.TEXT,
        width: 110,
        cellRenderer: ({ value }: ICellRendererParams) => value ? `<i class="main ${value.forIconName}"></i>${value.forDescription}` : ''
    },
    {
        headerName: i18n.tc('globalLocator.labels.portionType'),
        field: 'portionType.potName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.assignedProcessor'),
        colId: 'tissueProcessor.code',
        field: 'tissueProcessor',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT
    },
    {
        headerName: i18n.tc('globalLocator.labels.creationDate'),
        colId: 'porRequestDate',
        field: 'requestDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.firstPrinting'),
        colId: 'porPrintLabelDate',
        field: 'printLabelDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.processorEntryDate'),
        colId: 'porProcessingStartDate',
        field: 'processingStartDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.processorDepartureDate'),
        colId: 'porProcessingEndDate',
        field: 'processingEndDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.entryTechnician'),
        colId: 'processingStartPersonnel.normalizedFullName',
        field: 'processingStartPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.departureTechnician'),
        colId: 'processingEndPersonnel.normalizedFullName',
        field: 'processingEndPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.confectionTechnician'),
        colId: 'generationPersonnel.normalizedFullName',
        field: 'generationResponsiblePersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.confectionDate'),
        colId: 'porGenerationDate',
        field: 'generationDate',
        type: AgGridColumnType.DATETIME,
        exportType: AgGridExportType.DATETIME,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.cancellationDate'),
        colId: 'porCancellationDate',
        field: 'cancellationDate',
        type: AgGridColumnType.DATE,
        exportType: AgGridExportType.DATE,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.cancellationTechnician'),
        colId: 'cancellationPersonnel.normalizedFullName',
        field: 'cancellationTechnicianPersonnel.fullName',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('globalLocator.labels.incidents'),
        field: 'incidentsCount',
        type: AgGridColumnType.INCIDENT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.attachments'),
        field: 'attachmentsCount',
        type: AgGridColumnType.ATTACHMENT_COUNT,
        exportType: AgGridExportType.INTEGER,
        minWidth: 200,
        flex: 1
    },
    {
        headerName: i18n.tc('globalLocator.labels.observations'),
        colId: 'porNotes',
        field: 'notes',
        type: AgGridColumnType.TEXT,
        exportType: AgGridExportType.TEXT,
        suppressSizeToFit: true
    },
    {
        headerName: i18n.tc('global.laboratory'),
        field: 'currentLaboratory.labName',
        type: AgGridColumnType.LABORATORIES,
        exportType: AgGridExportType.TEXT
    }
]
